import * as DatabaseCaseCreationActions from './action';
const initialState = {
    databaseCaseCreationSuccess: [],
    databaseCaseCreationFailure: [],
}

const databaseCaseCreationComponentReducer = (state = initialState, action) => {
    switch (action.type) {
        case DatabaseCaseCreationActions.DATABASE_CASE_CREATION_SUCCESS:
            return state = {
                ...state,
                databaseCaseCreationSuccess: action.data
            }
        case DatabaseCaseCreationActions.DATABASE_CASE_CREATION_FAILURE:
            return state = {
                ...state,
                databaseCaseCreationFailure: action.data
            } 
        default: return state
        }
    };
    
export default databaseCaseCreationComponentReducer;